import type { O2dTableColumn } from '../types/table-column.type.js';

/**
 * Resolves the column's sort accessor with the `sortValue ?? filterValue`
 * default (mirroring the `O2dTableColumn` contract: sort falls back to filter).
 * Returns `undefined` when the column defines neither.
 */
export function resolveSortAccessor(
    column: O2dTableColumn
): ((row: unknown) => string | number) | undefined {
    return column.sortValue ?? column.filterValue;
}

/**
 * Safe-reads a row value through an optional accessor, returning `''` when the
 * accessor is absent or yields nullish. Preserves the `string | number` union so
 * the sort path can compare numerically — callers coerce to string themselves
 * when they need a case-insensitive text match.
 */
export function readAccessorValue(
    accessor: ((row: unknown) => string | number) | undefined,
    row: unknown
): string | number {
    return accessor?.(row) ?? '';
}
